(function (angular) {
    'use strict';

    angular.module('sms')

        /**
         *
         */
        .factory('trackingService',
            ['$http', '$q', 'jwtService', 'portalConfig',
                function ($http, $q, jwtService, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8001';

                    var fac = {
                        getAllTrackingData: getAllTrackingData,
                        setAllTrackingData: setAllTrackingData
                    };

                    return fac;

                    /**
                     * @param {string} id - the api space Id
                     */
                    function getAllTrackingData(id) {
                        return $http.get(urlBase + "/apispaces/" + id + "/sms/tracking")
                            .then(getAllTrackingDataComplete)
                            .catch(getAllTrackingDataFailed);

                        function getAllTrackingDataComplete(response) {
                            return response.data;
                        }

                        function getAllTrackingDataFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    /**
                     * @param {string} id - the api space Id
                     * @param {object} trackingData - all tracking data
                     */


                    function setAllTrackingData(id, trackingData) {
                        return $http.put(urlBase + "/apispaces/" + id + "/sms/tracking", trackingData)
                            .then(setTrackAllUrlsComplete)
                            .catch(setTrackAllUrlsFailed);

                        function setTrackAllUrlsComplete(response) {
                            return response.data;
                        }

                        function setTrackAllUrlsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                }]);

})(window.angular);
